/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Probe state
 */
export const TunnelDiagnosticStepState = {
  Pass: "pass",
  Fail: "fail",
  NotApplicable: "not_applicable",
  NotTested: "not_tested",
} as const;
/**
 * Probe state
 */
export type TunnelDiagnosticStepState = OpenEnum<
  typeof TunnelDiagnosticStepState
>;

export type TunnelDiagnosticStep = {
  /**
   * Elapsed probe time in milliseconds
   */
  durationMs: number;
  /**
   * Bounded failure category, never raw error text
   */
  failure: string;
  /**
   * Probe state
   */
  state: TunnelDiagnosticStepState;
};

/** @internal */
export const TunnelDiagnosticStepState$inboundSchema: z.ZodMiniType<
  TunnelDiagnosticStepState,
  unknown
> = openEnums.inboundSchema(TunnelDiagnosticStepState);

/** @internal */
export const TunnelDiagnosticStep$inboundSchema: z.ZodMiniType<
  TunnelDiagnosticStep,
  unknown
> = z.pipe(
  z.object({
    duration_ms: z.int(),
    failure: z.string(),
    state: TunnelDiagnosticStepState$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "duration_ms": "durationMs",
    });
  }),
);

export function tunnelDiagnosticStepFromJSON(
  jsonString: string,
): SafeParseResult<TunnelDiagnosticStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunnelDiagnosticStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunnelDiagnosticStep' from JSON`,
  );
}
